import { doctorConstants } from '../_constants/doctor.constants';
import { doctorService } from '../_services/doctor.service';

export function getAll() {
  return dispatch => {
    dispatch(request());

    doctorService.getAll()
      .then((collection) => {
        dispatch(success(collection));
      });
  }

  function request() { return { type: doctorConstants.GETALL_DOCTORS_REQUEST } }
  function success(collection) { return { type: doctorConstants.GETALL_DOCTORS_SUCCESS, collection } }
}